var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.471,
    height: 30.471,
    viewBox: "0 0 30.471 30.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 202",
    d: "M15.239 0h-.008A15.226 15.226 0 0 0 2.9 24.165L1 29.825l5.856-1.872A15.233 15.233 0 1 0 15.239 0z",
    style: {
      fill: "#4caf50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 203",
    d: "M21.073 18.205a4.3 4.3 0 0 1-2.99 2.15c-.8.169-1.836.3-5.336-1.146-4.477-1.855-7.361-6.4-7.585-6.7a8.7 8.7 0 0 1-1.809-4.6A4.864 4.864 0 0 1 4.91 4.206a2.214 2.214 0 0 1 1.558-.547c.189 0 .358.01.51.017.448.019.672.046.967.752.368.886 1.263 3.072 1.369 3.3a.907.907 0 0 1 .065.825 2.633 2.633 0 0 1-.493.7c-.225.259-.438.457-.663.735-.206.242-.438.5-.179.948A13.523 13.523 0 0 0 10.516 14a11.2 11.2 0 0 0 3.573 2.2.963.963 0 0 0 1.074-.169 18.434 18.434 0 0 0 1.19-1.577.85.85 0 0 1 1.093-.331c.411.143 2.588 1.219 3.036 1.442s.743.331.851.52a3.794 3.794 0 0 1-.26 2.12z",
    transform: "translate(3.032 3.309)",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.1c843ec0aff7ca7332fe7d00456c43c8.svg";
export { ForwardRef as ReactComponent };